const MODULES = {
    DASHBOARD: 1,
    USER_MODULE:2,
    PATIENT_MODULE:3,
    ADMIN_AREA:4
}
//last count 26
export default MODULES
